import React, { useState } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "./mobilemenu";

function Header() {
const [openDropdown, setOpenDropdown] = useState(null);
  return (
    <div id="pagee" className="clearfix">
      <header className="main-header fixed-header">
        <div className="header-lower">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner-header">

                {/* LEFT */}
                <div className="inner-header-left">
                  <div className="logo-box flex">
                    <div className="logo">
                      <Link to="/">
                        <img
                          src="https://www.nvrealestate.ae/images/logo/logo.webp"
                          alt="logo"
                        />
                      </Link>
                    </div>
                  </div>

                  {/* MAIN MENU */}
                  <nav className="main-menu show navbar-expand-md">
                    <ul className="navigation clearfix"> 
                      <li>
                       <Link to="/properties-for-sale">Buy</Link>
                      </li>

                      <li>
                        <Link to="/properties-for-rent">Rent</Link>
                      </li>
<li>
                       <Link to="/sell-your-property">Sell</Link>
                      </li>
                      <li>
                        <Link to="/new-projects">
                         New Projects
                        </Link>
                      </li> 
                       <li>
                        <Link to="/luxury-collection">
                         Luxury Collection
                        </Link>
                      </li> 
                       <li>
                        <Link to="/developers">
                         Developers
                        </Link>
                      </li> 
                  <li
  className="dropdown2"
  onMouseEnter={() => setOpenDropdown("services")}
  onMouseLeave={() => setOpenDropdown(null)}
>
  <Link to="#">Services</Link>

  {openDropdown === "services" && (
    <ul>
      <li>
        <Link to="/mortgage" onClick={() => setOpenDropdown(null)}>
          Mortgage Advisory 
        </Link>
      </li>

      <li>
        <Link to="/property-management" onClick={() => setOpenDropdown(null)}>
          Property Management
        </Link>
      </li>  
    
      <li>
        <Link to="/golden-visa-and-property-residency" onClick={() => setOpenDropdown(null)}>
          Golden Visa & Property Residency
        </Link>
      </li>
    </ul>
  )}
</li>
                    <li
  className="dropdown2"
  onMouseEnter={() => setOpenDropdown("about")}
  onMouseLeave={() => setOpenDropdown(null)}
>
  <Link to="#">About Us</Link>

  {openDropdown === "about" && (
    <ul>
      

      <li>
        <Link to="/team" onClick={() => setOpenDropdown(null)}>
          Team
        </Link>
      </li>

      <li>
        <Link to="/testimonials" onClick={() => setOpenDropdown(null)}>
          Testimonials
        </Link>
      </li>
      <li>
        <Link to="/blogs" onClick={() => setOpenDropdown(null)}>
          Market News & Trends
        </Link>
      </li>
    </ul>
  )}
</li>
                     
                      
                      <li>
                        <Link to="/contact-us">Contact us</Link>
                      </li>
                    </ul>
                  </nav>
                </div>

                {/* RIGHT */}
               
               <div className="inner-header-right header-account">
  <div className="flat-bt-top">
     <Link className="tf-btn-top primary" to="/sell-your-property">
      <svg
        width={21}
        height={20}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.625 14.375V17.1875C13.625 17.705 13.205 18.125 12.6875 18.125H4.5625C4.31386 18.125 4.0754 18.0262 3.89959 17.8504C3.72377 17.6746 3.625 17.4361 3.625 17.1875V6.5625C3.625 6.045 4.045 5.625 4.5625 5.625H6.125C6.54381 5.62472 6.96192 5.65928 7.375 5.72834M13.625 14.375H16.4375C16.955 14.375 17.375 13.955 17.375 13.4375V9.375C17.375 5.65834 14.6725 2.57417 11.125 1.97834C10.7119 1.90928 10.2938 1.87472 9.875 1.875H8.3125C7.795 1.875 7.375 2.295 7.375 2.8125V5.72834M13.625 14.375H8.3125C8.06386 14.375 7.8254 14.2762 7.64959 14.1004C7.47377 13.9246 7.375 13.6861 7.375 13.4375V5.72834M17.375 11.25V9.6875C17.375 8.94158 17.0787 8.22621 16.5512 7.69876C16.0238 7.17132 15.3084 6.875 14.5625 6.875H13.3125C13.0639 6.875 12.8254 6.77623 12.6496 6.60041C12.4738 6.4246 12.375 6.18614 12.375 5.9375V4.6875C12.375 4.31816 12.3023 3.95243 12.1609 3.6112C12.0196 3.26998 11.8124 2.95993 11.5512 2.69876C11.2901 2.4376 10.98 2.23043 10.6388 2.08909C10.2976 1.94775 9.93184 1.875 9.5625 1.875H8.625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      List Your Property
    </Link>
  </div>
</div>
 

                {/* MOBILE MENU */}
                <MobileMenu />
              </div>
            </div>
          </div>
        </div>
      </header>
    <>
  <div className="progress-wrap">
    <svg
      className="progress-circle svg-content"
      width="100%"
      height="100%"
      viewBox="-1 -1 102 102"
    >
      <path
        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
        style={{
          transition: "stroke-dashoffset 10ms linear 0s",
          strokeDasharray: "307.919, 307.919",
          strokeDashoffset: "286.138"
        }}
      />
    </svg>
  </div> 
</>

      </div>
    
  );
}

export default Header;
